function hideAlertAndSetEUCookie() {
    document.cookie = 'hideCookieAlert=1; expires=Tues, 31 Dec 2030 23:59:59 UTC; path=/';
    $(".footer-cookie").fadeOut(700);
    return true;
}

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

$(function() {
  if(getCookie("hideCookieAlert")){
    $(".footer-cookie").hide();
  }
});
